"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productsSearched = exports.searchStarted = void 0;
var constants_1 = require("../constants");
exports.searchStarted = function (_a) {
    var _b;
    var stats = _a.stats, session = _a.session;
    var props = (_b = {},
        _b[constants_1.EventProperty.SEARCH_START_TOTAL] = stats.totalSearchStart,
        _b[constants_1.EventProperty.USER_ID] = session.userID,
        _b[constants_1.EventProperty.CUSTOMER_NAME] = session.customer,
        _b[constants_1.EventProperty.SESSION_ID] = session.sessionID,
        _b);
    window.analytics.track(constants_1.EventName.SEARCH_STARTED, props);
};
exports.productsSearched = function (_a) {
    var _b;
    var stats = _a.stats, session = _a.session;
    var props = (_b = {},
        _b[constants_1.EventProperty.SEARCH_RESULTS] = stats.totalResults,
        _b[constants_1.EventProperty.SEARCH_TERM] = stats.term,
        _b[constants_1.EventProperty.SEARCH_TOTAL] = stats.totalSearches,
        _b[constants_1.EventProperty.USER_ID] = session.userID,
        _b[constants_1.EventProperty.CUSTOMER_NAME] = session.customer,
        _b[constants_1.EventProperty.SESSION_ID] = session.sessionID,
        _b);
    window.analytics.track(constants_1.EventName.PRODUCTS_SEARCHED, props);
};
